var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-wrap"},[_c('ezuikit-video',{attrs:{"video":{src:_vm.value,title:_vm.name,appKey:_vm.appKey,appSecret:_vm.appSecret,cameraType:_vm.cameraType,cameraSerialNumber:_vm.cameraSerialNumber,channelNo:_vm.channelNo}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }